import { render, staticRenderFns } from "./selaPromotionSale.vue?vue&type=template&id=aacb1a2a"
import script from "./selaPromotionSale.vue?vue&type=script&lang=js"
export * from "./selaPromotionSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports